import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack } from "@ui/components/Stack";
import { faBankmonitor } from "@ui/fortawesome/bankmonitor";

export const MenuItemBmBadge = () => {
	return (
		<Stack direction={"horizontal"} gap={1} className="align-items-center h6 bg-light rounded border p-1">
			<FontAwesomeIcon icon={faBankmonitor} className="text-primary" />
			<span className="small">
				Kizárólag a<br />
				Bankmonitornál!
			</span>
		</Stack>
	);
};
